import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Category from "../pages/category/page";
import Work from "../pages/work/page";
import Article from "../pages/article/page";
import About from "../pages/about/page";
import Search from "../pages/search/page";
import Articles from "../pages/articles/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category/:id",
    element: <Category />,
  },
  {
    path: "/work/:id",
    element: <Work />,
  },
  {
    path: "/article/:id",
    element: <Article />,
  },
  {
    path: "/articles",
    element: <Articles />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/search",
    element: <Search />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;